import { makeActionCreator } from '../../../redux-util/general-helpers';

export const toggleSearch = makeActionCreator('ui.common.library.toggleSearch');

export const setSearch = makeActionCreator('ui.common.library.setSearch');



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/common/library/actions.js